'use strict';
import angular from 'angular';

var apiInterceptorModule =angular.module(window.APP_NAME+'.apiInterceptor', []).factory('APIInterceptor', factory);

/* @ngInject */
function factory($q){
	return {
		'request':Request,
		'response':Response,
		'requestError':RequestError,
		'responseError':ResponseError
	};

	////////////////
	function Request(config){
		return config;
	}

	function Response(response){
		return response;
	}

	function RequestError(rejection){
		return $q.reject(rejection);
	}

	function ResponseError(rejection){
		if(rejection.data && rejection.data.Error && rejection.data.Error.Name == 'MigrationFailed'){
			window.location = '/migration-status.html';
		} else if(rejection.data && rejection.data.Error && rejection.data.Error.Name == 'DoesnotExistsError' && rejection.data.Error.Code == '5013'){
			window.location = '/404.html';
		} else if(rejection.status === 0){
			console.log('Connection Timeout');
		} else if(rejection.status === 500){
			if(!rejection.data){
				window.alert('I\'m sorry, something went wrong on our end. If it happens again send us feedback and we will get back to you asap.');
			}
		} else if(rejection.status === 401){
			window.location = '/logout';
		}
		return rejection;
	}
}
export default apiInterceptorModule;


// WEBPACK FOOTER //
// ./src/app/common/factories/api-interceptor.js